import { render, staticRenderFns } from "./TransactionsBody.vue?vue&type=template&id=0fb482e5&scoped=true&"
import script from "./TransactionsBody.vue?vue&type=script&lang=js&"
export * from "./TransactionsBody.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsBody.vue?vue&type=style&index=0&id=0fb482e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb482e5",
  null
  
)

export default component.exports